"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalErrorType = void 0;
exports.ModalErrorType = Object.freeze({
    NONE: 0,
    UNABLE_TO_SAVE_CHANGE: 1,
    UNABLE_TO_SAVE_SORT_ORDER: 2,
    UNABLE_TO_SAVE_SORT_ORDER_STALE_DATA: 3,
});
